module.exports = __webpack_public_path__ + "static/baby-2870b922b35b041571dc27a7b4f97e3d.jpg";